import React from 'react';
import {Link} from 'react-router-dom';
import Moment from 'react-moment';
import 'moment-timezone';
import Navigation from '../Navigation';
import Account from '../Account';
import Carousel from '../Carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock, faStar } from '@fortawesome/free-solid-svg-icons'
import logo from '../../images/new_logo.svg';
import loading from '../../images/loading.png';
import { isNotEmpty } from "../../util/user";
import renderIf from "render-if";
import { faLinkedin, faFacebook, faAngellist, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faBell, faMoneyBillAlt, faEnvelope } from '@fortawesome/free-regular-svg-icons'
import Helmet from "react-helmet";

export default class FullListing extends React.Component {
  constructor(props) {
    super(props);
    let listing;
    let listingId;
    let routed;
    let keysLength = Object.keys(props).length;

    if (keysLength === 0) {
      listing = undefined;
      routed = false;
      listingId = undefined;
    } else {
      if (props.match && props.match.path == "/listings/:id") {
        listing = undefined;
        routed = true;
        listingId = props.match.params.id;
      } else {
        listing = props.listing;
        routed = false;
        listingId = window.location.pathname.split("/").slice(-1)[0];
      }
    }

    this.state = {
      mounted: false,
      editView: false,
      listing: listing,
      listingId: listingId,
      routed: routed,
      loading: true,
      propertyImages: [],
      errorMessage: undefined,
      showModal: false,
      savedListing: false,
      email: "",
      fullName: "",
      phone: "",
      notifyMessage: undefined,
      closeModal: false
    }

    this.viewListing = this.viewListing.bind(this);
    this.changeImage = this.changeImage.bind(this);
    this.sendForm = this.sendForm.bind(this);
    this.updateFullName = this.updateFullName.bind(this);
    this.updateEmail = this.updateEmail.bind(this);
    this.updatePhone = this.updatePhone.bind(this);
    this.updateMessage = this.updateMessage.bind(this);
    this.hideMessageCtn = this.hideMessageCtn.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  hideMessageCtn() {
    this.setState({
      notifyMessage: undefined
    });
  }

  closeModal() {
    const state = !this.state.closeModal
    this.setState({
      closeModal: state
    });
  }

  addDefaultSrc(ev) {
    ev.target.src = logo;
  }

  updateEmail(e) {
    const state = this;

    this.setState({
      email: e.target.value
    })
  }

  updatePhone(e) {
    const state = this;

    this.setState({
      phone: e.target.value
    })
  }

  updateMessage(e) {
    const state = this;

    this.setState({
      message: e.target.value
    })
  }

  updateFullName(e) {
    const state = this;

    this.setState({
      fullName: e.target.value
    })
  }

  viewListing(id) {
    const listingID = id !== undefined ? id : this.state.listingId;
    const state = this;

    const token = localStorage.getItem("auth_token");
    var myHeaders = new Headers({
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    });

    var myInit = {
      method: 'GET',
      headers: myHeaders
    };

    var myRequest = new Request(`${process.env.REACT_APP_API_HOST}/api/listings/${listingID}`, myInit);

    fetch(myRequest)
    .then((json) => json.json())
    .then((content) => {
      let listing = content.listing;
      let propertyImages = content.property_images.slice(0, -1);

      state.setState({
        listing: listing,
        propertyImages: propertyImages,
        mounted: true,
        loading: false,
        currentImage: listing.Image
      });

      return content;
    });
  }

  componentDidMount() {
    this.viewListing();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match !== undefined) {
      if(this.props.match.params.id !== nextProps.match.params.id) {
        this.viewListing(nextProps.match.params.id)
      }
    }
  }

  changeImage(image) {
    this.setState({currentImage: image.Image})
  }

  sendForm(listingId) {
    console.log('listingId', listingId)

    const listingID = listingId !== undefined ? listingId : this.state.listing.ListingId;
    const state = this;

    let values = {};
    values = Object.assign({}, values, {
      listing_id: listingID,
      message: this.state.message,
      phone: this.state.phone,
      email: this.state.email,
      full_name: this.state.fullName,
    });

    (async () => {
      const token = localStorage.getItem("auth_token");
      var myHeaders = new Headers({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      });

      var myInit = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(values)
      };
      var myRequest = new Request(`${process.env.REACT_APP_API_HOST}/api/listing_messages/`, myInit);

      const rawResponse = await fetch(myRequest)
      const content = await rawResponse.json();

      state.setState({
        notifyMessage: "Successful message. We will contact you shortly! :)"
      });

      setTimeout(() => {
        state.setState({
          notifyMessage: undefined
        })
      }, 7000)

      return content;
    })();
  }

  render() {
    let listing = this.state.listing || undefined;
    // should be slug
    let rooms = [];

    if (listing) {
      rooms = [["RoomType1", listing.RoomType1],
              ["RoomType10", listing.RoomType10],
              ["RoomType11", listing.RoomType11],
              ["RoomType12", listing.RoomType12],
              ["RoomType13", listing.RoomType13],
              ["RoomType14", listing.RoomType14],
              ["RoomType15", listing.RoomType15],
              ["RoomType16", listing.RoomType16],
              ["RoomType17", listing.RoomType17],
              ["RoomType18", listing.RoomType18],
              ["RoomType19", listing.RoomType19],
              ["RoomType2", listing.RoomType2],
              ["RoomType20", listing.RoomType20],
              ["RoomType3", listing.RoomType3],
              ["RoomType4", listing.RoomType4],
              ["RoomType5", listing.RoomType5],
              ["RoomType6", listing.RoomType6],
              ["RoomType7", listing.RoomType7],
              ["RoomType8", listing.RoomType8],
              ["RoomType9", listing.RoomType9]]
      rooms = rooms.filter((room) => {
        return room[1] != undefined && room[1] != ""
      })

      rooms = rooms.map((room) => {
        let name = room[0]
        let value = room[1]
        let number = name.match(/\d+/g).map(Number);

        return {
          Level: listing[`RoomLevel${number}`],
          Type: listing[`RoomType${number}`],
          Dimensions: listing[`RoomDimensions${number}`]
        }
      })

      rooms = rooms.filter((room) => room.Type !== "" && room.Type !== undefined)
    }

    const q = listing ? encodeURIComponent(`${listing.StreetNumber} ${listing.StreetName} ${listing.PostalCode} ${listing.City} Ontario Canada`) : ""
    const qstring = `https://www.google.com/maps/embed/v1/place?q=${q}&key=AIzaSyAtkp9JV5_7WHFm6TatGKCLG8JJEEUMCHA`
    const currentImage = listing ? this.state.currentImage : ""

    const notify = this.state.notifyMessage;
    let notifyDetail = <div></div>

    if (notify !== undefined) {
        notifyDetail = <div onClick={this.hideMessageCtn} className="notification-ctn notify">
          {notify}
        </div>
    }

    // <a onClick={this.closeModal} className="cancel-modal">X</a>
    let userDivModal = <div>
      <div className="modal">
        <div className="modal-body">
          <Account updateUserForRoutes={this.props.updateUserForRoutes} user={this.props.user} />
        </div>
      </div>

      <div className="modal-outer"></div>
    </div>

    userDivModal = <div></div>

    console.log("this.props.user here brah")
    console.log(this.props.user)

    if (this.props.user && this.props.user.user && this.props.user.user.id) {
      console.log('setting modal')
      userDivModal = <div></div>
    }

    if (this.state.closeModal) {
      userDivModal = <div></div>
    }

    let mailLink;
    let twittertext;
    let facebooktext;
    let linkedintext;

    if (listing !== undefined) {
      mailLink = `mailto:example@gmail.com?subject=${listing.UnparsedAddress}body=${window.location.href}`
      twittertext = `https://twitter.com/intent/tweet?text=${window.location.href}`
      facebooktext = `https://www.facebook.com/sharer.php?u=${window.location.href}`
      linkedintext = `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}`
    }

    return (
      <div className="full-job-ctn">
        {listing && (
          <Helmet>
            <title>{'Hamilton Homes -' + listing.UnparsedAddress}</title>
            <meta name="description" content={listing.description}/>
            <meta name="keywords" content={"buying,communities,ancaster,stoney creek,niagara,waterdown, grimsby, burlington, Flamborough, dundas, brantford, amilton,homes,for,sale,niburski,search,condos,luxury,business" + listing.keywords}/>

            <meta property="og:url" content={"https://besthamiltonhouses.com/posts" + listing.slug}/>
            <meta property="og:title" content={"Hamilton Homes - " + listing.UnparsedAddress}/>
            <meta property="og:description" content={listing.description}/>
          </Helmet>
        )}

        <div className="job-outline">
          {!listing &&
            <div id="loading-state"><img src={loading} /></div>
          }

          {listing && (
            <div className="full-job-details-stacked listing-page">
              <div className="heading">
                <h2>{listing.UnparsedAddress}</h2>
              </div>

              <div className="listing-ctn-flex">
              <div className="images">
                <div className="current-image">
                  <Carousel
                    type="scan"
                    id="about"
                    items={this.state.propertyImages} />
                </div>

                <div className="social-media">
                  <a href={twittertext} target="_blank"><FontAwesomeIcon icon={faTwitter} /></a>
                  <a href={linkedintext} target="_blank"><FontAwesomeIcon icon={faLinkedin} /></a>
                  <a href={facebooktext} target="_blank"><FontAwesomeIcon icon={faFacebook} /></a>
                  <a href={mailLink} target="_blank"><FontAwesomeIcon icon={faEnvelope} /></a>
                </div>
              </div>

              <div className="listing-info">
                <div className="content">
                  <div className="right">
                    <section>
                      <h2 className="small-heading">Details {listing.ListingId}</h2>
                      <h3>Bedrooms {listing.BedroomsTotal}</h3>
                      <h3>List Price: ${parseInt(listing.ListPrice).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</h3>
                      <h3>Bedrooms: {listing.BedroomsTotal}</h3>
                      <h3>Bathrooms: {listing.BathroomsTotal}</h3>
                      <h3>Square Feet: {listing.BuildingAreaTotal}</h3>
                      <h3>City: {listing.City}</h3>
                      <h3>Property Type: {listing.PropertyType}</h3>
                      <h3>Ownership Type: {listing.OwnershipType}</h3>
                      <h3>Lot Size Area: {listing.LotSizeArea}</h3>
                      <h3>Year Built: {listing.YearBuilt}</h3>
                    </section>

                    <section>
                      <h2 className="small-heading">Primary Features</h2>
                      <h3>Style: {listing.ArchitecturalStyle}</h3>

                      <div className="public-remarks">
                        {listing.PublicRemarks}
                      </div>
                    </section>

                    <section>
                      <h2 className="small-heading">Financial Details</h2>
                      <h3>Status: For Sale</h3>
                    </section>

                    <section>
                      <h2 className="small-heading">Extra Info</h2>
                      <h3>Subdivision { listing.SubdivisionName}</h3>
                      <h3>Garage {listing.GarageYN}</h3>
                      <h3>Sewer { listing.Sewer}</h3>
                      <h3>Heating { listing.Heating}</h3>
                      <h3>Heating Fuel { listing.HeatingFuel}</h3>
                      <h3>Cooling { listing.Cooling}</h3>
                    </section>

                    <section>
                      <h2 className="small-heading">Rooms</h2>
                      {rooms.map((room, index) =>
                        <h3 key={"p-room" + index}>
                          {room.Type} ({room.Level}): {room.Dimensions}
                        </h3>
                      )}
                    </section>
                  </div>
                </div>
              </div>
            </div>

              <div className="contact-form">
                <h2 className="small-heading centered">Contact About {listing.ListingId}</h2>

                <div className="inputs">
                  <div className="input-form">
                    <div className="label">
                      Full Name
                    </div>

                    <input onChange={this.updateFullName.bind(this)} value={this.state.fullName} className="input"></input>
                  </div>

                  <div className="input-form half-form first-form">
                    <div className="label">
                      Email address
                    </div>

                    <input onChange={this.updateEmail.bind(this)} value={this.state.email} className="input"></input>
                  </div>

                  <div className="input-form half-form">
                    <div className="label">
                      Phone
                    </div>

                    <input onChange={this.updatePhone.bind(this)} value={this.state.phone} className="input"></input>
                  </div>

                  <div className="input-form">
                    <div className="label">
                      Message
                    </div>

                    <textarea onChange={this.updateMessage.bind(this)} value={this.state.message} className="input"></textarea>
                  </div>

                  <div onClick={() => this.sendForm(listing.ListingId)} className="button">
                    Send
                  </div>
                </div>
              </div>

              <div className="full-listing-idx">
                <img src="https://s3.amazonaws.com/staticos.idxbroker.com/mls-logos/b579-logoURL-idxsandbox" alt="" />

                <div className="text">
                  © 2019 REALTORS® Association of Hamilton-Burlington (RAHB). All rights reserved. The data relating to real estate for sale on this web site comes in part from the Internet Data Exchange Program of RAHB. Real estate listings held by IDX Brokerage firms other than Prosession Homes are marked with the Internet Data Exchange logo or the Internet Data Exchange thumbnail logo and detailed information about them includes the name of the listing Brokers. Information provided is deemed reliable but not guaranteed.
                </div>

                <br />
                <br />
              </div>
            </div>
          )}

          {notifyDetail}
          {userDivModal}
        </div>
      </div>
    )
  }
}
